import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const IFrame = styled.iframe`
  width: 100%;
  aspect-ratio: 16 / 9;
  border: none;
  background-color: #eee;

  ${mq.smallOnly} {
    margin: 0 calc(var(--container-spacing) * -1);
    width: calc(100% + 2 * var(--container-spacing));
  }
`
